import React, {useContext} from "react";
import LanguageContext from "../context/language";

export const PageHeader = (props) => {
    const {language} = useContext(LanguageContext);
    const enPage = "https://www.archeologia.uw.edu.pl/en/new-main-page/";
    const plPage = "https://www.archeologia.uw.edu.pl/";

    const renderSubtitle = () => {
        if (props.subtitle) {
            return <span className="subtitle">{props.subtitle}</span>;
        } else if (props.overviewSubtitle) {
            const { university, institute, department } = props.overviewSubtitle;
            return (
                <span>
                    <a href="https://www.uw.edu.pl">{university}</a>, <a
                    href={language === "pl" ? plPage : enPage}>{institute}</a>, {department}
                </span>
                );
        }
    };

    const determineHeader = () => {
        let header = language === 'en' ? 'Bioarchaeological survey of the Near East' : 'Badania bioarcheologiczne na Bliskim Wschodzie';

        if (props.imageClass.includes('header-school-')) {
            header = language === 'en' ? 'Summer school in Iran' : 'Szkoła letnia w Iranie';
        }

        return header;
    };

    const headerClasses = "jumbotron-fluid page-header screen-wide-image " + props.imageClass;

    return (
        <header className={headerClasses}>
            <div className="container header-container">
                <h1>{determineHeader()}
                    {renderSubtitle()}
                </h1>
            </div>
        </header>
    )
};
